// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fab4a6f6","453":"9f87badf","727":"7885445d","732":"d40b7963","977":"1fe7e625"}[chunkId] + ".chunk.js";
};